import { HotelWithOffers } from "~/applications/OfferSearch/Domain/HotelWithOffers";
import { Offer } from "~/applications/OfferSearch/Domain/Offer";

type SortedOffers = {
  numberOfHotels: number;
  isDestinationSoldOut: boolean;
  offersByHotel: Array<HotelWithOffers>;
  soldOutOffers: Array<Offer>;
};

const useOffersSorter = ({
  offers,
}: {
  offers: Array<Offer> | undefined;
}): SortedOffers | undefined => {
  if (offers === undefined || offers.length === 0) {
    return undefined;
  }

  const offersSortedByAvailability = offers.reduce(
    () => {
      return offers.reduce(
        (acc, offer) => {
          if (offer.isSoldOut()) {
            acc.soldOutOffers.push(offer);
          } else {
            acc.availableOffers.push(offer);
          }

          return acc;
        },
        {
          availableOffers: [] as Array<Offer>,
          soldOutOffers: [] as Array<Offer>,
        },
      );
    },
    {} as {
      availableOffers: Array<Offer>;
      soldOutOffers: Array<Offer>;
    },
  );

  const hotelWithOffers = offers.reduce((acc, offer) => {
    const hotel = acc.find((loge) => loge.id === offer.unitGroup.loge.id);

    if (hotel) {
      hotel.offers.push(offer);
    } else {
      acc.push({
        ...offer.unitGroup.loge,
        offers: [offer],
        numberOfAvailableOffers: 0,
      });
    }

    return acc;
  }, [] as Array<HotelWithOffers>);

  hotelWithOffers.forEach((hotel) => {
    hotel.offers = hotel.offers.filter((oneOffer) => !oneOffer.isSoldOut());
  });

  hotelWithOffers.forEach((hotel) => {
    hotel.numberOfAvailableOffers = hotel.offers.length;
  });

  return {
    numberOfHotels: hotelWithOffers.length,
    isDestinationSoldOut:
      offersSortedByAvailability.availableOffers.length === 0,
    offersByHotel: hotelWithOffers,
    soldOutOffers: offersSortedByAvailability.soldOutOffers,
  };
};

export default useOffersSorter;
